import React from 'react';

export default class MultiChoice extends React.PureComponent {
  constructor(props){
    super(props);

    this.setAnswer = this.setAnswer.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  handleKeyUp(e){
    this.setAnswer(String.fromCharCode(e.keyCode), true);
    this.props.handleKeyUp(e);
  }

  setAnswer(answer){
    this.props.updateItem({answer: answer});
  }

  render(){
    const isAnswer = val => (this.props.answer === val);
    const isCorrectAnswer = val => (this.props.correctAnswer === val);
    const hasCorrectAnswer = this.props.teacherView && this.props.correctAnswer != undefined;

    let selfClasses = ['choices'];
    if (hasCorrectAnswer)  selfClasses.push('has-correct-answer');
    if ((this.props.answer || '').length > 0)  selfClasses.push('answered');

    const span_content = this.props.answer_options.map((answer_opt, i) => {
      let classes = ['choice'];
      if (isAnswer(answer_opt))  classes.push('active');
      if (isCorrectAnswer(answer_opt))  classes.push('correct-answer');
      if (this.props.itemDisabled)  classes.push('manually-disabled');
      return <div key={answer_opt} className={classes.join(' ')} onClick={e => this.setAnswer(answer_opt)}>{answer_opt}</div>;
    });

    return (
        <div className={selfClasses.join(' ')}>
          {span_content}
        </div>
    );
  }

}
